import { createClient } from '@supabase/supabase-js'
import type { Database } from '@/integrations/supabase/types'
import { isNative, nativeStorageAdapter } from './storage';
import { CAN_USE_REALTIME } from '@/utils/isSecureRealtime';

// Prefer Vite env; fall back to your project defaults (keep these valid for local dev)
const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL?.trim() ||
  'https://daeuiiggqdxyseiekbca.supabase.co';

export const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY?.trim() ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRhZXVpaWdncWR4eXNlaWVrYmNhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkyODkwODEsImV4cCI6MjA2NDg2NTA4MX0.7qQvHxFz47SA7b4RswfjS6sP6CZokZbhtEctrupb5M8';

const supabaseFunctionsUrl = 
  import.meta.env.VITE_SUPABASE_FUNCTIONS_URL?.trim() ||
  'https://daeuiiggqdxyseiekbca.functions.supabase.co';

// Simple validation (informative warnings only)
if (!supabaseUrl || !supabaseAnonKey) {
  console.error('[Supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY!');
}
if (!supabaseFunctionsUrl) {
  console.error('[Supabase] Missing VITE_SUPABASE_FUNCTIONS_URL!');
}

// Create client with correct session detection for web/native
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: !isNative(), // <-- THIS LINE IS THE CRITICAL FIX!
    ...(isNative() ? { storageAdapter: nativeStorageAdapter } : {}),
    flowType: 'pkce',
  },
  global: {
    fetch,
    headers: {
      'x-prayai-client': 'webapp',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
    timeout: 20000,
  },
})

export function safeSubscribe<T extends { subscribe: Function }>(
  channel: T,
  onStatus?: (s: any) => void
) {
  if (!CAN_USE_REALTIME) {
    console.warn('[realtime] skipped subscribe (context not WS-safe)');
    return { status: 'skipped', unsubscribe: () => {} };
  }
  try {
    // @ts-ignore supabase types
    return channel.subscribe((s: any) => onStatus?.(s));
  } catch (e) {
    console.warn('[realtime] subscribe threw (WS blocked by Safari):', e);
    return { status: 'error', unsubscribe: () => {} };
  }
}

// --- Optional: lightweight dev logging to confirm token flow ---
if (import.meta.env.DEV) {
  supabase.auth.getSession().then(({ data }) => {
    console.log('[SUPABASE] session userId:', data.session?.user?.id ?? null)
    console.log('[SUPABASE] functions URL:', supabaseFunctionsUrl)
  })
}
